import React, { useState, useRef } from 'react';
import LeftSidebar from '../Tools/LeftSidebar';
import Topbar from '../Tools/Topbar';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';

const HelpAndSupport = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const {settings, updateSetting, handleColorTheme } = useSettings();
  const settingsRef = useRef();

  return (
    <div id="main-wrapper">
      <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
            <Settings
              ref={settingsRef}
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}  // Add this line
            />
                <div className="card help-support-panel w-100 position-relative overflow-hidden">
                  <div className="px-4 py-3 ">
                    <h5 className="card-title fw-semibold mb-0 lh-sm">Help & Support</h5>
                    <p className="card-subtitle mb-0 mt-1">Find answers, tutorials, and ways to reach our team</p>
                  </div>
                  <div className="card-body p-4">
                    <form className="position-relative mb-5">
                      <input type="search" className="form-control search-invoice ps-5" id="text-srh" placeholder="Search Help Articles..." />
                      <i className="ti ti-search position-absolute top-50 start-0 translate-middle-y fs-6 text-dark ms-3"></i>
                    </form>

                    <h5 className="card-title fw-semibold mb-4 lh-sm">FAQ</h5>
                    <div className="accordion accordion-flush" id="accordionFlushExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header mb-2" id="flush-headingOne">
                          <button className="accordion-button p-3 collapsed text-dark" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                            How do I add a new resource?
                          </button>
                        </h2>
                        <div id="flush-collapseOne" className="accordion-collapse collapse " aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample" style={{}}>
                          <div className="accordion-body">
                            Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header mb-2" id="flush-headingTwo">
                          <button className="accordion-button p-3 collapsed text-dark" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                            How are critical alerts triggered?
                          </button>
                        </h2>
                        <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample" style={{}}>
                          <div className="accordion-body">
                            Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header mb-2" id="flush-headingThree">
                          <button className="accordion-button p-3 collapsed text-dark" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                            Can I change my user role?
                          </button>
                        </h2>
                        <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample" style={{}}>
                          <div className="accordion-body">
                            Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-lg-6 my-2">
                        <div className="card w-100 h-100 mb-0">
                          <div className="card-body p-4">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h5 className="card-title fw-semibold">User Guides</h5>
                              </div>
                            </div>
                            <div className="card mt-4 mb-0 shadow-none">
                              <div className="table-responsive">
                                <table className="table mb-0 align-middle text-nowrap">
                                  <thead>
                                    <tr>
                                      <th className="ps-0">Guide Title</th>
                                      <th>Format</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody className="text-dark ">
                                    <tr>
                                      <td className="ps-0">User Onboarding Guide</td>
                                      <td><i className="ti ti-file-type-pdf"></i> PDF</td>
                                      <td><a href="#" className="text-primary">Download PDF</a></td>
                                    </tr>
                                    <tr>
                                      <td className="ps-0">Admin Dashboard Manual</td>
                                      <td><i className="ti ti-file-type-pdf"></i> PDF</td>
                                      <td><a href="#" className="text-primary">Download PDF</a></td>
                                    </tr>
                                    <tr>
                                      <td className="ps-0">Resource Management Workflow</td>
                                      <td><i className="ti ti-file-type-pdf"></i> PDF</td>
                                      <td><a href="#" className="text-primary">Download PDF</a></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 my-2">
                        <div className="card w-100 h-100 mb-0">
                          <div className="card-body p-4">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h5 className="card-title fw-semibold">Contact Support</h5>
                              </div>
                            </div>
                            <div className="card mt-4 mb-0 shadow-none">
                              <div className="row">
                                <div className="col-lg-4"><p>Support Email:</p></div>
                                <div className="col-lg-8"><a className="text-primary">support@rosystem.org</a></div>
                              </div>
                              <div className="row">
                                <div className="col-lg-4"><p>Support Phone:</p></div>
                                <div className="col-lg-8"><a className="text-primary">+91 90000 00000</a></div>
                              </div>
                              <div className="row">
                                <div className="col-lg-4"><p>Support Hours:</p></div>
                                <div className="col-lg-8"><a className="text-primary">Mon–Fri, 9AM to 6PM IST</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      
  );
};

export default HelpAndSupport;
